import { Badge, Col, Image, Switch, Table, message } from "antd";
import { get, isEmpty } from "lodash";
import dayjs from "dayjs";
import React, { useCallback, useEffect, useState } from "react";
import services from "services";

import NoImagePlaceholderBlend from "../../../../../images/NoImagePlaceholderBlend.png";

const IMAGE_STYLE = {
  justifySelf: "center",
  width: "80%",
  height: "64px",
  objectFit: "cover",
  borderRadius: "0.3rem"
};

const ProfileTaskPage = ({ dataSource, onChangeTotal, listFilter = [] }) => {
  const [isFetching, setIsFetching] = useState(false);

  const [tableData, setTableData] = useState({
    dataSource: [],
    total: 0
  });

  const [tableConfig, setTableConfig] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: true
    }
  });

  const [tableSubConfig, setTableSubConfig] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: true
    }
  });
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [getAllData, setGetAllData] = useState(false);

  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "stt",
      align: "center",
      width: "5%",
      render: (_, __, index) => getIndex(index)
    },
    {
      title: "Ngày",
      key: "date",
      align: "center",
      dataIndex: "date",
      render: value => {
        return dayjs(value, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
    },
    {
      title: "Kho",
      key: "station_name",
      align: "center",
      dataIndex: "station_name"
    },
    {
      title: "Công việc",
      align: "center",
      dataIndex: "task_type_name"
    },
    {
      title: "Loại thiết bị",
      dataIndex: "device_name",
      align: "center"
    },
    {
      title: "Vị trí",
      dataIndex: "station_position",
      align: "center"
    },
    {
      title: "Độ ưu tiên",
      dataIndex: "priority",
      align: "center",
      render: value => {
        return <span>{`Cấp ${value}`}</span>;
      }
    },
    {
      title: "Mô tả",
      dataIndex: "task_name"
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      align: "center",
      render: (value, item) => {
        if ("DOING" === value) {
          return (
            <p>
              <Badge
                color="orange"
                text={`${listFilter?.task_status?.[value] || value}`}
              />
            </p>
          );
        } else if ("DONE" === value) {
          return (
            <>
              <div>
                <Badge
                  color="green"
                  text={`${listFilter?.task_status?.[value] || value}`}
                />
              </div>

              <div>
                {item["finished_time"]
                  ? dayjs(item["finished_time"]).format("DD/MM/YYYY HH:mm:ss")
                  : ""}
              </div>
            </>
          );
        } else if ("PAST_DUE" === value) {
          return (
            <p>
              <Badge
                color="f50"
                text={`${listFilter?.task_status?.[value] || value} `}
              />
            </p>
          );
        }
      }
    }
  ];

  const expandedRowRender = record => {
    const columns_device = [
      {
        title: "Chi tiết công việc",
        dataIndex: "content",
        render: text => {
          return <div style={{ whiteSpace: "pre-line" }}>{text}</div>;
        }
      },
      {
        title: "Trạng thái",
        dataIndex: "status",
        align: "center",
        render: value => {
          if ("FINISHED" !== value) {
            return (
              <p>
                <Badge
                  color="#f50"
                  text={`${listFilter?.sub_task_status?.[value] || value}`}
                />
              </p>
            );
          } else {
            return (
              <p>
                <Badge
                  color="green"
                  text={`${listFilter?.sub_task_status?.[value] || value}`}
                />
              </p>
            );
          }
        }
      },
      {
        title: "Ảnh/Video",
        dataIndex: "media_url",
        align: "center",
        render: value => {
          if (!value) return "";
          return value?.map((item, index) => (
            <Image
              key={index}
              style={IMAGE_STYLE}
              src={item || NoImagePlaceholderBlend}
              fallback={NoImagePlaceholderBlend}
              height={64}
              preview={item || false}
            />
          ));
        }
      }
    ];

    const sub_data = record?.sub_data || [];
    const total = record?.total_sub_data || 0;

    return (
      <Table
        bordered
        rowKey={"subtask_id"}
        columns={columns_device}
        dataSource={sub_data}
        pagination={{
          ...tableSubConfig.pagination,
          total: total
        }}
        onChange={async pagination => {
          let params = await handleGetDetailTask({
            parent_task_id: record.task_id,
            page: pagination.current - 1,
            size: pagination.pageSize
          });

          let id = record.task_id;
          let cloneData = JSON.parse(JSON.stringify(tableData.dataSource));

          let result = updateNodeValueByTitle(cloneData, id, params);
          if (result) {
            setTableData(prev => ({
              ...prev,
              dataSource: JSON.parse(JSON.stringify(cloneData))
            }));
          }
          onChangeSubTable(pagination);
        }}
      />
    );
  };

  const getTaskData = useCallback(async params => {
    setIsFetching(true);
    let res = await services.GdmsService.getProfileTasks(params);
    setIsFetching(false);
    const isSuccess = get(res, "success");
    let data = [];
    if (isSuccess) {
      data = get(res, "data", []);
    }
    let total = get(res, "total_elements", 0);
    setTableData(prev => {
      let next = { ...prev };
      next.dataSource = data;
      next.total = total;
      return next;
    });
    onChangeTotal(total);
    setExpandedRowKeys([]);
    setIsFetching(false);
  }, []);

  const onChangeTable = pagination => {
    setTableConfig(prev => ({ ...prev, pagination }));
  };

  const onChangeSubTable = pagination => {
    setTableSubConfig(prev => ({ ...prev, pagination }));
  };

  let getIndex = index =>
    (tableConfig.pagination.current - 1) * tableConfig.pagination.pageSize +
    index +
    1;

  function updateNodeValueByTitle(tree, id, params) {
    let founded = false;
    tree.forEach(node => {
      if (node.task_id === id) {
        node.sub_data = params.sub_data;
        node.total = params.total;
        founded = true;
        return;
      }
      if (node.sub_data && founded === false) {
        founded = updateNodeValueByTitle(node.sub_data, id, params);
      }
    });

    return founded;
  }

  const handleGetDetailTask = async params => {
    setIsFetching(true);
    let res = await services.GdmsService.getDetailProfileTask(params);
    setIsFetching(false);
    const isSuccess = get(res, "success");
    let data = [];
    let total = 0;

    if (isSuccess) {
      data = get(res, "data", []);
      total = get(res, "total_elements", 0);
    } else {
      message.error(get(res, "message", "Có lỗi khi lấy thông tin chi tiết."));
    }

    return { sub_data: data, total };
  };

  useEffect(
    () => {
      if (isEmpty(dataSource)) return;
      let params = {
        page: tableConfig.pagination.current - 1,
        size: tableConfig.pagination.pageSize,
        station_id: dataSource?.station_id,
        device_id: dataSource?.device_id,
        get_all_date: getAllData
      };

      getTaskData(params);
    },
    [tableConfig, getTaskData, dataSource, getAllData]
  );

  return (
    <div
      style={{
        height: 350
      }}
    >
      <Col span={24}>
        <div className="d-flex align-items-end justify-content-end">
          <div>
            Tất cả:{" "}
            <Switch
              size="small"
              checked={getAllData}
              onChange={checked => {
                setGetAllData(checked);
              }}
            />
          </div>
        </div>
      </Col>

      <Col span={24} className="mt-3">
        <Table
          size="small"
          columns={columns}
          loading={isFetching}
          dataSource={tableData.dataSource}
          rowKey="task_id"
          pagination={{
            ...tableConfig.pagination,
            total: tableData.total
          }}
          onChange={onChangeTable}
          scroll={{
            y: 250
          }}
          expandable={{
            expandedRowRender,
            onExpand: async (expanded, record) => {
              if (expanded) {
                let params = await handleGetDetailTask({
                  parent_task_id: record.task_id,
                  page: 0,
                  size: 20
                });
                let id = record.task_id;
                let cloneData = JSON.parse(
                  JSON.stringify(tableData.dataSource)
                );

                let result = updateNodeValueByTitle(cloneData, id, params);
                if (result) {
                  setTableData(prev => ({
                    ...prev,
                    dataSource: JSON.parse(JSON.stringify(cloneData))
                  }));
                }

                setExpandedRowKeys([...expandedRowKeys, id]);
              } else {
                setExpandedRowKeys(
                  expandedRowKeys.filter(key => key !== record.task_id)
                );
              }
            },
            expandedRowKeys: expandedRowKeys
          }}
        />
      </Col>
    </div>
  );
};

export default React.memo(ProfileTaskPage);
